if (window.initialized)
  throw new Error('Stop execution');

/* Simple JavaScript Inheritance
  * By John Resig http://ejohn.org/
  * MIT Licensed.
  */
// Inspired by base2 and Prototype
(function () {
  var initializing = false, fnTest = /xyz/.test(function () {xyz;}) ? /\b_super\b/ : /.*/;


  // The base Class implementation (does nothing)
  this.Class = function () { };

  // Create a new Class that inherits from this class
  Class.extend = function (prop) {
    var _super = this.prototype;

    // Instantiate a base class (but only create the instance,
    // don't run the init constructor)
    initializing = true;
    var prototype = new this();
    initializing = false;

    // Copy the properties over onto the new prototype
    for (var name in prop) {
      // Check if we're overwriting an existing function
      prototype[name] = typeof prop[name] == "function" &&
        typeof _super[name] == "function" && fnTest.test(prop[name]) ?
        (function (name, fn) {
          return function () {
            var tmp = this._super;

            // Add a new ._super() method that is the same method
            // but on the super-class
            this._super = _super[name];

            // The method only need to be bound temporarily, so we
            // remove it when we're done executing
            var ret = fn.apply(this, arguments);
            this._super = tmp;

            return ret;
          };
        })(name, prop[name]) :
        prop[name];
    }

    // The dummy class constructor
    function Class() {
      // All construction is actually done in the init method
      if (!initializing && this.init)
        this.init.apply(this, arguments);
    }

    // Populate our constructed prototype object
    Class.prototype = prototype;

    // Enforce the constructor to be what we expect
    Class.prototype.constructor = Class;

    // And make this class extendable
    Class.extend = arguments.callee;

    return Class;
  };
})();

var ImageLoader = {};

ImageLoader.count = 0;
ImageLoader.loaded = 0;
ImageLoader.isImagesLoaded = function () {
  return this.count == this.loaded;
};
ImageLoader.imageLoaded = function () {
  this.loaded++;
  if (this.isImagesLoaded())
    this.callback(this.loaded_images);
};
ImageLoader.addImage = function (src) {
  var that = this;

  this.count++;
  var _image = new Image();
  _image.src = src;
  _image.onload = function () {
    that.imageLoaded();
  }
  return _image;
};
ImageLoader.Load = function (images, callback) {
  this.loaded_images = jQuery.extend(true, {}, images);
  this.callback = callback;
  var that = this;

  jQuery.each(this.loaded_images, function (key, value) {
    if (!jQuery.isArray(this) && this instanceof String) {
      that.loaded_images[key] = that.addImage(this);
    }
    else {
      var arr = this,
        _key = key;
      jQuery.each(arr, function (key, value) {
        arr[key] = that.addImage(this);
      });
    }
  });

};

(function ($) {
  $(function () {
    var AnimationItem = Class.extend({
      type: "animation",
      init: function (options) {
        this.options = $.extend({}, options);

        this.Kinetics = [];
        this.KineticCounter = 0;
        this.step = 0;
        this.stepInc = this.stepInc || 0.04;

        this.isUsing = false;
        this.isDone = false;
        this.time = 0;

        this.build();
      },
      getCoordinates: function () {
        var element = this.Kinetics[this.KineticCounter];
        return [element.getX(), element.getY()]
      },
      build: function () {

      },
      animationDone: function () {
        this.isDone = true;
        this.KineticCounter--;
      },
      draw: function (params) {
        this.time += params.frame.timeDiff;
        this.isUsing = true;
      },
      getElement: function () {
        var element = this.Kinetics[this.KineticCounter];
        this.KineticCounter++;
        if (this.KineticCounter > this.Kinetics.length - 1) {
          this.animationDone();
        }

        return element;

      },
      getState: function () {
        var that = this;

        return {
          time: this.time,
          done: this.isDone
        }
      }
    });

    var Saw = AnimationItem.extend({
      init: function (options) {
        var that = this;

        this._super(options);

        this.opacity = 1;
        $("#saw-container").css("opacity", this.opacity);

        this.x = 0;

        var sawImg = window.saw_image;

        this.paper = {};

        this.paper.draw = function () {
          var delta = this.dx / 3,
            context = that.options.context;

          if (this.dx > that.options.canvas.width - 400 && that.opacity > 0) {
            context.globalAlpha = that.opacity;
            that.opacity -= 0.02;
          }

          context.save();

          context.translate(this.dx, 50);

          context.beginPath();
          context.moveTo(-100, 0);
          context.lineTo(100, 0);
          context.lineTo(100, -50);
          context.lineTo(-100, -50);
          context.closePath();
          context.clip();

          context.rotate(this.rotate * Math.PI / 30)
          context.drawImage(sawImg, -50, -50);
          context.restore();

          context.save();
          context.translate(this.dx + 50, 50);

          for (var i = 0; i < 7; i++) {
            context.beginPath();
            context.moveTo(0, 0);
            context.lineTo(-70 * (Math.random() + 0.5), -50 * (Math.random() + 0.2));
            context.closePath();

            context.lineWidth = 1;
            context.strokeStyle = this.colors[Math.floor(Math.random() * this.colors.length)];
            context.stroke();
          }
          context.restore();

        }
        this.paper.rotate = 0;
        this.paper.dx = 0;
        this.paper.colors = [
          '#FFE09D'
        ]
      },
      draw: function (frame) {
        this.x = 0.5 * frame.time;
        //this.x += 10;
        this.paper.dx = this.x;
        this.paper.rotate++;
        this.paper.draw();

        if (this.x > this.options.canvas.width + 100) {
          this.animationDone();
          return false;
        }

        return true;

      }
    })

    var images = {
      saw: "/assets/images/saw.png"
    };

    ImageLoader.Load(images, function (loaded_images) {
      window.saw_image = loaded_images.saw;
    });

    window.onload = function () {

      window.animationHandler = {
        allowed: function () {
          return !!document.createElement("canvas").getContext;
        },
        active: false
      }

      window.requestAnimFrame = (function (callback) {
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame ||
          function (callback) {
            window.setTimeout(callback, 1000 / 60);
          };
      })();

      window.animationHandler.start = function (handler) {
        if (!window.animationHandler.allowed() || window.animationHandler.active) {
          handler();
          return;
        }

        if ($('#index-slider').length)
          $('#index-slider').flexslider("pause");

        var canvas = document.getElementById('saw'),
          context = canvas.getContext('2d');
        var selector = $("body").scrollTop() == 0 ? "html" : "body";

        $(selector).animate({
          scrollTop: 0
        }, 500, function () {
          canvas.width = $("div.content-wrapper").width();
          canvas.height = 150;

          $("#saw-container").css("top", $("div.content-wrapper").offset().top - 40);
          $("#saw-container").css("left", $("div.content-wrapper").offset().left);
          var saw = new Saw({context: context, canvas: canvas});

          var frame = {
            time: 0,
            timeDiff: new Date().getTime()
          },
            lastTime = new Date().getTime();

          function animate() {
            context.clearRect(0, 0, canvas.width, canvas.height);

            var time = new Date().getTime();
            frame.timeDiff = time - lastTime;
            frame.time += frame.timeDiff;
            lastTime = time;

            if (saw.draw(frame)) {
              requestAnimFrame(function () {
                animate()
              });
            } else {
              window.animationHandler.active = false;
              canvas.width = 0;
              canvas.height = 0;
            }

          }

          window.animationHandler.active = true;
          animate();
          handler();
        });
      }
    };
  });
})(jQuery);